import { Link } from '@tanstack/react-router';
import type { MouseEvent } from 'react';
import logo from '../../assets/images/logo.svg';
import type { Theme } from '../../types/theme.ts';
import CartIndicator from '../cart/cart-indicator';
import Icon from '../icon.tsx';
import styles from './header.module.scss';

interface Props {
  theme: Theme;
  onThemeChange: (theme: Theme) => void;
}

export default function Header({ theme, onThemeChange }: Props) {
  const siteTitle = 'Pixwrist';
  const handle = 'karkotok'; // the collection's slug in Shopify

  const handleThemeClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onThemeChange(theme === 'light' ? 'dark' : 'light');
  };

  return (
    <header className={`${styles.header} container-fluid`}>
      <div className="centered">
        <nav className={styles.nav}>
          <div className={styles.navLeft}>
            <Link to="/" className={styles.logo}>
              <img
                src={logo}
                width="34"
                height="32"
                alt={`${siteTitle} logo`}
              />
            </Link>
            <ul className={styles.menu}>
              <li>
                <Link
                  to="/$handle"
                  params={{ handle }}
                  className={styles.link}
                  activeProps={{ className: 'active' }}
                >
                  Karkötők
                </Link>
              </li>
            </ul>
          </div>
          <div className={styles.navRight}>
            <ul className={styles.menu}>
              <li>
                <a
                  href="#"
                  className={styles.link}
                  onClick={handleThemeClick}
                  aria-label="Téma váltás"
                >
                  <Icon
                    className={styles.themeIcon}
                    name={theme === 'light' ? 'moon' : 'sun'}
                    size={24}
                  />
                  <span className={styles.linkText}>
                    {theme === 'light' ? 'Sötét' : 'Világos'} mód
                  </span>
                </a>
              </li>
              <li>
                <Link
                  to="/favourites"
                  className={styles.link}
                  activeProps={{ className: 'active' }}
                  aria-label="Kedvencek"
                >
                  <Icon className={styles.heartIcon} name="heart" size={24} />
                  <span className={styles.linkText}>Kedvencek</span>
                </Link>
              </li>
              <li>
                <CartIndicator />
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
}
